import React, { useState } from 'react';
import { gql, useMutation, useQuery } from "@apollo/client";
import '../App.css';

const GET_SALIDA = gql`
  query getSalidas {
    getSalidas {
      _id
      fecha
      concepto
      cantidad
    }
  }
`;

const ELIMINAR_SALIDA = gql`
  mutation eliminarSalida($id: ID!) {
    eliminarSalida(_id: $id)
  }
`;

const ACTUALIZAR_SALIDA = gql`
  mutation editarSalida($id: ID!, $nuevaCantidad: Int) {
    editarSalida(_id: $id, cantidad: $nuevaCantidad) {
      _id
      fecha
      concepto
      cantidad
    }
  }
`;

function FiltrarEgresos() {
  const [filtroCantidad, setFiltroCantidad] = useState("");
  const [terminoBusqueda, setTerminoBusqueda] = useState("");
  const [editingSalida, setEditingSalida] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(0);
  const [editarSalida] = useMutation(ACTUALIZAR_SALIDA);
  const { loading, error, data } = useQuery(GET_SALIDA);
  const [eliminarSalida] = useMutation(ELIMINAR_SALIDA, {
    refetchQueries: [{ query: GET_SALIDA }]
  });

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  const totalSalidas = data.getSalidas.reduce((acumulador, salida) => acumulador + salida.cantidad, 0);
  const reversedData = data.getSalidas.slice().reverse();

  return (
    <div>
      <div className="card card-total">
        <h1>Total egresos</h1>
        <h1>{totalSalidas}</h1>
      </div>
      <div className="container">
        <form>
          <label htmlFor="terminoBusqueda">Buscar por Concepto:</label>
          <input
            type="text"
            id="terminoBusqueda"
            value={terminoBusqueda}
            onChange={(e) => setTerminoBusqueda(e.target.value)}
          />
          <button type="submit">Aplicar Filtro</button>
        </form>
        <div className="row">
          {reversedData.map((salida) => {
            if (
              (filtroCantidad === "" || salida.cantidad > parseInt(filtroCantidad)) &&
              (terminoBusqueda === "" || salida.concepto.toLowerCase().startsWith(terminoBusqueda.toLowerCase()))
            ) {
              return (
                <div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" key={salida._id}>
                  <div className="card-body">
                    <h3 className="card-title">{salida.concepto}</h3>
                    <h4 className="card-text">{salida.fecha}</h4>
                    <h4 className="card-text">{salida.cantidad}</h4>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        eliminarSalida({ variables: { id: salida._id } });
                      }}
                      disabled={loading}
                    >
                      eliminar
                    </button>
                    {editingSalida === salida._id ? (
                      <>
                        <input
                          type="number"
                          value={nuevaCantidad}
                          onChange={(e) => setNuevaCantidad(parseInt(e.target.value))}
                        />
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            editarSalida({
                              variables: { id: salida._id, nuevaCantidad },
                            });
                            setEditingSalida(null);
                            setNuevaCantidad(0);
                          }}
                        >
                          Guardar
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            setEditingSalida(salida._id);
                            setNuevaCantidad(salida.cantidad);
                          }}
                        >
                          Editar
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    </div>
  );
}

export default FiltrarEgresos;
